module.exports = __webpack_public_path__ + "static/media/slide5.b1a407f9.gif";